<template>
  <ModalConfirmation
    data-test-id="DeleteAccount__modal"
    :showModal="showModal"
    :title="title"
  >
    <template v-slot:body>
      <ParagraphBody :class="$style.headerText">
        Are you sure you want to delete the AWS Account {{ awsAccountNumber }} from Cloud Insights?
      </ParagraphBody>
      <ParagraphBody>
        Deleting an account will stop event ingestion
        and require re-onboarding of the account to restart it.
      </ParagraphBody>
      <ParagraphBody>
        Please confirm by entering the last four digits of the AWS account you would like to delete.
      </ParagraphBody>
      <InputText
        v-model="awsAccountNumberConfirm"
        :class="$style.inputAccountID"
        data-test-id="DeleteAccount__input"
        label="Last four of AWS Account ID"
        name="Last four of AWS Account ID"
        placeholder="0000"
        :required="true"
        :rules="`required|digits:4|is:${lastFour}`"
        showValidationMessage
      />
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <ButtonSecondary
          data-test-id="DeleteAccountModal__cancelButton"
          :hasOutline="false"
          text="cancel"
          @click="cancel"
        />
        <Button
          data-test-id="DeleteAccountModal__deleteButton"
          hasOutline=""
          icon="delete"
          :isDisabled="isDisabled"
          :isLoading="isSaving"
          text="Delete"
          type="error"
          @click="deleteAccount"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonSecondary,
  InputText,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';

const title = 'Delete AWS Account';
const cloudInsightsAccountsCollection = StoreModuleMap[ItemTypeConsts.cloudInsightsAccounts];

export default {
  name: 'DeleteAccountModal',

  components: {
    Button,
    ButtonGroup,
    ButtonSecondary,
    InputText,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    accountID: {
      type: String,
      required: true,
    },

    awsAccountNumber: {
      type: String,
      required: true,
    },

    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      awsAccountNumberConfirm: '',
      isSaving: false,
      title,
    };
  },

  computed: {
    isDisabled() {
      return this.awsAccountNumberConfirm !== this.lastFour;
    },

    lastFour() {
      return this.awsAccountNumber.substr(-4);
    },
  },

  methods: {
    ...mapActions(cloudInsightsAccountsCollection, ['deleteItem']),

    cancel() {
      this.awsAccountNumberConfirm = '';
      this.$emit('cancel');
    },

    async deleteAccount() {
      this.isSaving = true;

      await this.deleteItem({
        accountID: this.accountID,
        awsAccountNumber: this.awsAccountNumber,
      });

      this.awsAccountNumberConfirm = '';
      this.isSaving = false;
      this.$emit('delete');
    },
  },
};
</script>

<style scoped module>
.headerText {
  font-weight: 600 !important;
}

.inputAccountID {
  min-height: 6rem;
}
</style>
